export const APP_FILE_SUPPORT_TICKETS_LIST = "/support-tickets";
export const APP_FILE_SUPPORT_TICKETS = "/manage-support-tickets";